import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent, IonIcon } from '@ionic/angular/standalone';
import { DisplayService } from "@qid/core";
import { Environment, ENVIRONMENT } from "@qid/env";
import { SuperButtonComponent, SuperInputComponent } from '@qid/super';
import { QRCodeComponent } from 'angularx-qrcode';
import { ScannersFacade } from "../../+state/scanners.facade";
import { UpdateScannerDto } from "../../dto/update-scanner.dto";
import { Scanner } from "../../models/scanner";
import { SexyModule } from '@qid/sexy';
import { CommonModule } from '@angular/common';
import { TemplateSelectorComponent } from '../../../../components/template-selector/template-selector.component';

@Component({
  selector: 'app-add-template-option',
  templateUrl: './add-template-option.component.html',
  styleUrls: ['./add-template-option.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SuperButtonComponent,
    SuperInputComponent,
    QRCodeComponent,
    SexyModule,
    TemplateSelectorComponent,
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonContent,
    IonIcon
  ]
})
export class AddTemplateOptionComponent implements OnInit {

  baseUrl: string = this.env.collectUrl;

  @Input() scanner: Scanner = new Scanner();


  @Input() qrCode: string;
  @Input() closeButton: boolean = false;
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  public slides = {
    selectForms: 'selectForms',
    setTitle: 'setTitle',
  };

  public activeSlide: string = this.slides.selectForms;

  constructor(
    private scannerFacade: ScannersFacade,
    private modalController: ModalController,
    private displayService: DisplayService,
    @Inject(ENVIRONMENT) private env: Environment
  ) {
  }

  ngOnInit() {

  }

  ionViewDidEnter() {
  }

  update = async () => {
    let dto = new UpdateScannerDto();
    dto.optionsTitle = this.scanner.optionsTitle;
    dto.scannerTemplateOptions = this.scanner.scannerTemplateOptions;
    dto.commonTitle = this.scanner.commonTitle;
    const res = await this.scannerFacade.updateRecord(this.scanner._id, dto);
    if (!res) {
      throw 'Some error occurred while updating option.';
    }
    this.scanner = res;
    this.close();
    await this.displayService.toast({
      message: 'QR Updated Successfully',
      color: 'success'
    });
  };

  createScanner = async () => {
    if (
      this.scanner.scannerTemplateOptions.length > 1 &&
      this.scanner.commonTitle.length < 1
    ) {
      throw 'Please enter a QR Title';
    }

    await this.scannerFacade.create(
      this.qrCode,
      this.scanner.scannerTemplateOptions,
      this.scanner.commonTitle
    );

    await this.displayService.toast({
      message: 'Added Successfully',
      color: 'success'
    });
    return this.close(1);
  };

  compareSelect(o1, o2) {
    return o1._id === o2._id;
  }

  close(event: number = null) {
    if (this.closeButton) {
      return this.closed.emit(event);
    }
    this.modalController.dismiss({
      scanner: { ...this.scanner },
    });
  }

  onFormsSelected = async () => {
    if (this.scanner.scannerTemplateOptions.length < 1) {
      throw 'Please select at least one form';
    }

    if (
      this.scanner.scannerTemplateOptions.length > 1 &&
      (!this.scanner.commonTitle || this.scanner.commonTitle?.length < 1)
    ) {

      return this.goToSlide(this.slides.setTitle);
    }

    if (this.scanner._id) {
      return this.update();
    }
    return this.createScanner();
  };

  goToSlide(slide: string) {
    this.activeSlide = slide;
  }


  getQrShortCode() {
    if (this.qrCode) {
      return this.qrCode?.slice(-5);
    }
    return this.scanner?.qr?.slice(-5);
  }
}
